import { Voters } from './voters';
import { AccessPermissionRequest } from './request';

export class Permissions extends Voters {
    /**
     *  Query the permissions for the specified workspace member to perform actions, possibly against specific target.
     *
     * @param {{ workspace: * }} user Queried workspace entity descriptor
     * @param {string} role User role (tariff plan)
     * @param {string} permission Permission string (resource[:(action|?|*)])
     * @param {*} [subject] Target, against which the query is executed
     * @returns {boolean} Result of querying
     */
    isGranted(user, role, permission, subject) {
        return this.vote(new AccessPermissionRequest(user, subject, role, permission));
    }
}
